import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
import Spacings, { createCustomSpacing, } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
const FooterTheme = {
    footerDoormat: {
        light: {
            backgroundColor: Colors.lightGrey,
            link: {
                color: Colors.black,
                hoverColor: withOpacity(Colors.black, Opacities.medium),
                focusColor: withOpacity(Colors.black, Opacities.medium),
                activeColor: withOpacity(Colors.black, Opacities.medium),
            },
            padding: {
                top: {
                    mobile: Spacings.large,
                    tablet: Spacings.xLarge,
                    desktop: createCustomSpacing(40 / 16),
                },
                bottom: {
                    mobile: Spacings.xxLarge,
                    tablet: Spacings.none,
                    desktop: Spacings.none,
                },
            },
            verticalContentPadding: {
                mobile: Spacings.xxLarge,
            },
            states: {
                enabled: {
                    textColor: withOpacity(Colors.black, Opacities.medium),
                },
                disabled: {
                    textColor: withOpacity(Colors.black, Opacities.medium),
                },
                hover: {
                    textColor: Colors.black,
                },
                active: {
                    textColor: Colors.accessibleSafetyOrange,
                },
            },
        },
        dark: {
            backgroundColor: Colors.black,
            link: {
                color: Colors.white,
                hoverColor: withOpacity(Colors.white, Opacities.medium),
                focusColor: withOpacity(Colors.white, Opacities.medium),
                activeColor: withOpacity(Colors.white, Opacities.medium),
            },
            states: {
                enabled: {
                    textColor: withOpacity(Colors.white, Opacities.medium),
                },
                disabled: {
                    textColor: withOpacity(Colors.white, Opacities.low),
                },
                hover: {
                    textColor: Colors.white,
                },
                active: {
                    textColor: Colors.accessibleSafetyOrange,
                },
            },
        },
    },
    footer: {
        light: {
            backgroundColor: Colors.lightGrey,
            padding: {
                mobile: Spacings.large,
                tablet: Spacings.xLarge,
                desktop: createCustomSpacing(40 / 16),
            },
            legal: {
                pipeColor: withOpacity(Colors.black, Opacities.medium),
            },
        },
        dark: {
            backgroundColor: Colors.black,
            legal: {
                pipeColor: withOpacity(Colors.white, Opacities.medium),
            },
        },
    },
};
export default FooterTheme;
